/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	__webpack_require__(28);
	
	var _init = __webpack_require__(3);
	
	var _init2 = _interopRequireDefault(_init);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _init2.default)();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _init = __webpack_require__(3);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _drawing = __webpack_require__(10);
	
	var _barba = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $html = (0, _jquery2.default)('html');
	var $head = (0, _jquery2.default)('head');
	
	/**
	 * Gets the "metadata" from the next page.
	 * In this case, it's a custom JSON script tag for passing custom settings that can be intercepted by the Javascript.
	 * For example, you can pass an array of HTML classes to be added to the HTML element, where previous page classes are
	 * removed automatically.
	 *
	 * NOTE: Currently this metadata must exist within the Barba container element. TODO Support any location on the page.
	 *
	 * @param container
	 * @returns Object
	 */
	function getMetadata(container) {
		var $metadata = (0, _jquery2.default)(container).find('script[data-pjax-metadata]');
		var metadata = void 0;
	
		try {
			metadata = JSON.parse($metadata.text());
		} catch (e) {
			metadata = {};
		}
	
		return metadata;
	}
	
	/**
	 * Initialises the metadata settings for the page.
	 *
	 * @param metadata
	 */
	function initMetadata() {
		var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = Object.keys(metadata)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var key = _step.value;
	
				var value = metadata[key];
				switch (key) {
	
					case 'htmlClasses':
						{
							if (Array.isArray(value)) {
								$html.addClass(value.join(' '));
							}
						}
						break;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}
	
	/**
	 * Destroys the metadata settings for the page.
	 *
	 * @param metadata
	 */
	function destroyMetadata() {
		var metadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;
	
		try {
			for (var _iterator2 = Object.keys(metadata)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var key = _step2.value;
	
				var value = metadata[key];
				switch (key) {
	
					case 'htmlClasses':
						{
							if (Array.isArray(value)) {
								$html.removeClass(value.join(' '));
							}
						}
						break;
				}
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	}
	
	/*
	 * Create the page transition.
	 */
	_barba.Pjax.getTransition = function () {
		return _barba.BaseTransition.extend({
			start: function start() {
				var _this = this;
	
				Promise.all([this.newContainerLoading, this.fadeOut()]).then(function () {
					return _this.fadeIn();
				}).catch(function (e) {
					return console.error('Error navigating page:', e);
				});
			},
			fadeOut: function fadeOut() {
	
				destroyMetadata(getMetadata(this.oldContainer));
	
				(0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, { duration: 400 });
	
				return (0, _jquery2.default)(this.oldContainer).animate({ opacity: 0 }).promise();
			},
			fadeIn: function fadeIn() {
				var _this2 = this;
	
				initMetadata(getMetadata(this.newContainer));
	
				var $oldContainer = (0, _jquery2.default)(this.oldContainer);
				var $newContainer = (0, _jquery2.default)(this.newContainer);
	
				$oldContainer.hide();
	
				$newContainer.css({
					visibility: 'visible',
					opacity: 0
				});
	
				(0, _init2.default)(this.newContainer);
	
				$newContainer.animate({ opacity: 1 }, 400, function () {
					return _this2.done();
				});
			}
		});
	};
	
	/*
	 * Run tagged scripts for the new page.
	 */
	var $prevScripts = (0, _jquery2.default)('script[data-pjax-script]');
	var firstRun = true;
	_barba.Dispatcher.on('newPageReady', function (currentStatus, prevStatus, newContainer, rawHtml) {
		if (!firstRun) {
			var $wrapper = (0, _jquery2.default)('<div>');
			$wrapper.html(rawHtml);
	
			var $scripts = $wrapper.find('script[data-pjax-script]');
	
			$prevScripts.remove();
			$prevScripts = $scripts;
	
			$head.append($scripts);
		} else {
			firstRun = false;
		}
	});
	
	/*
	 * Let's go!
	 */
	_barba.Pjax.start();
	_barba.Prefetch.init();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	exports.default = init;
	
	var _links = __webpack_require__(4);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _scroller = __webpack_require__(5);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _toggler = __webpack_require__(7);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _autosize = __webpack_require__(11);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _floatLabel = __webpack_require__(13);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	var _validator = __webpack_require__(14);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _lightbox = __webpack_require__(16);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	var _playOnHover = __webpack_require__(18);
	
	var _playOnHover2 = _interopRequireDefault(_playOnHover);
	
	var _swiper = __webpack_require__(19);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _lazyLoad = __webpack_require__(20);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	var _parallax = __webpack_require__(22);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _reveal = __webpack_require__(25);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _sticky = __webpack_require__(26);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	   var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	   (0, _links2.default)(context);
	   (0, _scroller2.default)(context);
	   (0, _toggler2.default)(context);
	   (0, _autosize2.default)(context);
	   (0, _floatLabel2.default)(context);
	   (0, _validator2.default)(context);
	   (0, _lightbox2.default)(context);
	   (0, _playOnHover2.default)(context);
	   (0, _swiper2.default)(context);
	   (0, _lazyLoad2.default)(context);
	   (0, _parallax2.default)(context);
	   (0, _reveal2.default)(context);
	   (0, _sticky2.default)(context);
	}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = linksEnhancement;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');
	
	/**
	 * Improves the functionality of links depending on their URL's.
	 *
	 * @param context
	 */
	function linksEnhancement() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    // Forces new window clicks for asset files
	    $context.find('a').each(function () {
	        var $a = (0, _jquery2.default)(this);
	        var href = String($a.attr('href')).toLowerCase();
	
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = assetExtensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var ext = _step.value;
	
	                if (href.endsWith('.' + ext)) {
	                    $a.attr('target', '_blank');
	                    break;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    });
	
	    // Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
	    $context.find('a, button').on('click', function () {
	        (0, _jquery2.default)(this).trigger('blur');
	    });
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scrollerDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $body = (0, _jquery2.default)('html, body');
	var docEl = document.documentElement;
	
	var breakable = true;
	var breakTimeout = null;
	var bound = false;
	
	/**
	 * Scrolls to a point on the page when an element is clicked.
	 *
	 * Scrolls to top: <button sw-scroller="top">Top</button>
	 * Scrolls to bottom: <button sw-scroller="bottom">Bottom</button>
	 * Scrolls to element by ID: <button sw-scroller="#element">Element</button>
	 *
	 * @param context
	 */
	function scrollerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-scroller]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-scroller');
	        var settings = (0, _parse.directiveSettings)(json, {
	            to: 'top',
	            selector: null,
	            speed: 500
	        }, 'to');
	
	        $element.on('click', function (e) {
	            e.preventDefault();
	
	            clearInterval(breakTimeout);
	            breakable = false;
	            breakTimeout = setTimeout(function () {
	                return breakable = true;
	            }, 100);
	
	            var top = 0;
	            switch (settings.to) {
	                case 'top':
	                    top = 0;break;
	                case 'bottom':
	                    top = docEl.scrollHeight - docEl.clientHeight;break;
	                case 'element':
	                    top = (0, _jquery2.default)(settings.selector).offset().top;break;
	                default:
	                    top = (0, _jquery2.default)(settings.to).offset().top;
	            }
	
	            $body.animate({ scrollTop: Math.min(top, docEl.scrollHeight - docEl.clientHeight) }, { duration: settings.speed });
	        });
	    });
	
	    if (!bound) {
	        bound = true;
	        $body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function (e) {
	            if (breakable && e.which > 0) {
	                switch (e.type) {
	                    case 'mousedown':
	                    case 'mousewheel':
	                    case 'touchstart':
	                        $body.stop();break;
	                }
	            }
	        });
	    }
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.directiveSettings = directiveSettings;
	/**
	 * Parses the JSON from a directive.
	 *
	 * @param data
	 * @param defaults
	 * @param targetProperty
	 */
	function directiveSettings(data) {
	    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var targetProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var settings = Object.assign({}, defaults);
	
	    if (data) {
	        var parsedData = void 0;
	
	        try {
	            parsedData = JSON.parse(data);
	        } catch (e) {
	            parsedData = data;
	        }
	
	        if (parsedData instanceof Object && !Array.isArray(parsedData)) {
	            Object.assign(settings, parsedData);
	        } else if (targetProperty) {
	            settings[targetProperty] = parsedData;
	        } else {
	            console.error("Error parsing settings: \"" + data + "\"");
	        }
	    }
	
	    return settings;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = togglerDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _toggler = __webpack_require__(8);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Toggles the visual display of an element on the page.
	 * Contains action directives for interacting with a toggler element:
	 *  - toggler-open
	 *  - toggler-close
	 *  - toggler-toggle
	 *
	 * @param context
	 */
	function togglerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-toggler]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler');
	        var settings = (0, _parse.directiveSettings)(json, {
	            open: true,
	            transition: false
	        }, 'open');
	
	        var toggler = new _toggler2.default(this, settings);
	
	        $element.data('toggler', toggler);
	    });
	
	    var _arr = ['open', 'close', 'toggle'];
	
	    var _loop = function _loop() {
	        var action = _arr[_i];
	
	        $context.find('[sw-toggler-' + action + ']').each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-toggler-' + action);
	            var settings = (0, _parse.directiveSettings)(json, {
	                target: null,
	                on: 'click',
	                prevent: true
	            }, 'target');
	
	            $element.on(settings.on, function (e) {
	                var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	                var toggler = $target.data('toggler');
	
	                if (toggler) {
	                    toggler[action]();
	                }
	
	                if (settings.prevent) {
	                    e.preventDefault();
	                }
	            });
	        });
	    };
	
	    for (var _i = 0; _i < _arr.length; _i++) {
	        _loop();
	    }
	
	    $context.find('[sw-toggler-class]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler-class');
	        var settings = (0, _parse.directiveSettings)(json, {
	            target: null,
	            openClass: 'is-open',
	            closedClass: 'is-closed'
	        }, 'target');
	
	        var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	        var toggler = $target.data('toggler');
	
	        if (toggler) {
	            var updateClasses = function updateClasses() {
	                $element.removeClass(toggler.isOpen ? settings.closedClass : settings.openClass);
	                $element.addClass(toggler.isOpen ? settings.openClass : settings.closedClass);
	            };
	
	            toggler.on('toggle', updateClasses);
	            updateClasses();
	        }
	    });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transitionTypes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _emitter = __webpack_require__(9);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Map of transition types.
	 */
	var transitionTypes = exports.transitionTypes = {
	
	    css: {
	        init: function init(toggler) {
	            toggler.$element[0].addEventListener('transitionend', function (e) {
	                if (e.target === toggler.$element[0]) {
	                    toggler.transitionEnd();
	                }
	            });
	        }
	    },
	
	    height: {
	        init: function init(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        },
	        start: function start(toggler) {
	            if (toggler.isOpen) {
	                toggler.$element.slideDown(300, function () {
	                    return toggler.transitionEnd();
	                });
	            } else {
	                toggler.$element.slideUp(300, function () {
	                    return toggler.transitionEnd();
	                });
	            }
	        },
	        skip: function skip(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        }
	    }
	};
	
	/**
	 * Toggler class for toggling the visual state of an element.
	 */
	
	var Toggler = function (_Emitter) {
	    _inherits(Toggler, _Emitter);
	
	    /**
	     *
	     * @param element
	     * @param settings
	     */
	    function Toggler(element) {
	        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Toggler);
	
	        var _this = _possibleConstructorReturn(this, (Toggler.__proto__ || Object.getPrototypeOf(Toggler)).call(this));
	
	        _this.$element = (0, _jquery2.default)(element);
	        _this.isOpen = typeof settings.open === 'boolean' ? settings.open : true;
	        _this.transition = settings.transition in transitionTypes ? settings.transition : false;
	
	        _this.transitionInit();
	        return _this;
	    }
	
	    /**
	     *
	     * @param isOpen
	     * @param transition
	     */
	
	
	    _createClass(Toggler, [{
	        key: 'toggle',
	        value: function toggle(isOpen, transition) {
	            isOpen = typeof isOpen === 'boolean' ? isOpen : !this.isOpen;
	            transition = typeof transition === 'boolean' ? transition : true;
	
	            if (this.isOpen !== isOpen) {
	                this.isOpen = isOpen;
	
	                if (this.transition && transition) {
	
	                    this.transitionStart();
	                } else {
	
	                    this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	                    this.transitionSkip();
	                }
	
	                this.trigger('toggle');
	                this.trigger(this.isOpen ? 'open' : 'close');
	            }
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'open',
	        value: function open(transition) {
	            this.toggle(true, transition);
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'close',
	        value: function close(transition) {
	            this.toggle(false, transition);
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionInit',
	        value: function transitionInit() {
	            this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.init) {
	                transitionType.init(this);
	            }
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionStart',
	        value: function transitionStart() {
	
	            if (this.isOpen) {
	
	                if (this.$element.hasClass('is-before-closing')) {
	
	                    this.$element.removeClass('is-before-closing').addClass('is-open');
	                } else if (this.$element.hasClass('is-closing')) {
	
	                    this.$element.removeClass('is-before-closing is-closing').addClass('is-opening');
	                } else {
	
	                    this.$element.removeClass('is-closed').addClass('is-before-opening');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-opening').addClass('is-opening');
	                }
	            } else {
	
	                if (this.$element.hasClass('is-before-opening')) {
	
	                    this.$element.removeClass('is-before-opening').addClass('is-closed');
	                } else if (this.$element.hasClass('is-opening')) {
	
	                    this.$element.removeClass('is-opening').addClass('is-closing');
	                } else {
	
	                    this.$element.removeClass('is-open').addClass('is-before-closing');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-closing').addClass('is-closing');
	                }
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.start) {
	                transitionType.start(this);
	            }
	
	            this.trigger('transitionStart');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionEnd',
	        value: function transitionEnd() {
	            if (this.isOpen) {
	
	                this.$element.removeClass('is-opening').addClass('is-open');
	            } else {
	
	                this.$element.removeClass('is-closing').addClass('is-closed');
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.end) {
	                transitionType.end(this);
	            }
	
	            this.trigger('transitionEnd');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionSkip',
	        value: function transitionSkip() {
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.skip) {
	                transitionType.skip(this);
	            }
	        }
	    }]);
	
	    return Toggler;
	}(_emitter2.default);
	
	exports.default = Toggler;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Emitter = function () {
	    function Emitter() {
	        _classCallCheck(this, Emitter);
	
	        this.events = {};
	    }
	
	    _createClass(Emitter, [{
	        key: "on",
	        value: function on(type, callback) {
	            if (!(type in this.events)) {
	                this.events[type] = [];
	            }
	            this.events[type].push(callback);
	        }
	    }, {
	        key: "off",
	        value: function off(type) {
	            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (callback && type in this.events) {
	                var newList = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.events[type][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var cb = _step.value;
	
	                        if (cb !== callback) {
	                            newList.push(cb);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                this.events[type] = newList;
	            } else {
	                delete this.events[type];
	            }
	        }
	    }, {
	        key: "trigger",
	        value: function trigger(type) {
	            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (type in this.events) {
	                event.type = type;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = this.events[type][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var cb = _step2.value;
	
	                        cb.call(this, event);
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	        }
	    }]);
	
	    return Emitter;
	}();
	
	exports.default = Emitter;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.frame = frame;
	exports.unframe = unframe;
	exports.redraw = redraw;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requests an animation frame.
	 *
	 * @param callback
	 * @returns {*}
	 */
	function frame(callback) {
	    if (typeof requestAnimationFrame === 'undefined') {
	        return setTimeout(callback, 0);
	    }
	    return requestAnimationFrame(callback);
	}
	
	/**
	 * Cancels a frame request.
	 *
	 * @param id
	 */
	function unframe(id) {
	    if (typeof cancelAnimationFrame === 'undefined') {
	        return clearTimeout(id);
	    }
	    return cancelAnimationFrame(id);
	}
	
	/**
	 * Triggers a layout reflow for a specific element.
	 *
	 * @param element
	 */
	function redraw(element) {
	    if (element instanceof _jquery2.default) {
	        element.each(redraw);
	    }
	    // Accessing this property triggers a layout reflow
	    element.offsetWidth;
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = autosizeDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(12);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
	 *
	 * @see https://github.com/jackmoore/autosize
	 * @param context
	 */
	function autosizeDirective() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  var $context = (0, _jquery2.default)(context);
	  (0, _autosize2.default)($context.find('textarea[sw-autosize]'));
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.21
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : (function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				'delete': function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = ta.clientWidth;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				var originalHeight = ta.style.height;
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight !== styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map['delete'](ta);
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = floatLabelDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(12);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Applies the correct class names to the field.
	 *
	 * @param e - The event object
	 */
	function setState() {
	    var _this = this;
	
	    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = (0, _jquery2.default)(this);
	
	    // Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
	    // problem with the "keydown" event in that the key value is added to the field after the event has been
	    // called. This means the value of the field returned will be the previous value. The timeout ensures that
	    // the input happens before the value is checked.
	    setTimeout(function () {
	
	        // Enhance the file input by outputting information about the selected file
	        if (field.is('input[type="file"]')) {
	            var div = field.siblings('div');
	            var fileName = '';
	
	            if (_this.files && _this.files.length > 1) {
	                fileName = _this.files.length + ' files selected';
	            } else {
	                fileName = _this.value.split('\\').pop();
	            }
	
	            div.html(fileName);
	        }
	
	        field.closest('[sw-float-label]')
	
	        // Set the field type as a class to the float label wrapper
	        .addClass('-type-' + field.prop('tagName').toLowerCase())
	
	        // Is the element in focus?
	        .toggleClass('is-focused', e.type == 'focus' || field.is(':focus'))
	
	        // Check if the fields value is an empty string. This works for select options that have an empty
	        // value. This can be exploited by creating an empty option, disabling it and setting it as the
	        // default.
	        .toggleClass('is-filled', !!field.val())
	
	        // Only apply if browser supports field validation
	        .toggleClass('is-invalid', field[0].validity && !field[0].validity.valid)
	
	        // Specifically for textarea's. This is useful so that the label can be hidden when the content is
	        // scrolled, so that the label and the fields text don't overlap and look ugly.
	        .toggleClass('is-scrolled', field.scrollTop() > 0);
	    });
	}
	
	/**
	 * Adds float label behaviour to marked fields.
	 *
	 * @param context
	 */
	function floatLabelDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	
	    (0, _jquery2.default)(context).find('[sw-float-label]').find('input, select, textarea').on('focus blur change keyup keydown scroll', setState).each(setState);
	}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = validatorDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Parsley library.
	 *
	 * @see http://parsleyjs.org/
	 * @type {string}
	 */
	var parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.7.2/';
	
	/**
	 * Enhances forms with live validation.
	 *
	 * @param context
	 */
	function validatorDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $forms = $context.find('form[sw-validator]');
	
	    // Only load Parsley if there are forms on the page
	    if ($forms.length > 0) {
	        (0, _request.dependency)(parsleyDir + 'parsley.min.js', function () {
	            return window.Parsley;
	        }).then(function () {
	            $forms.each(function () {
	                var $form = (0, _jquery2.default)(this);
	                var parsley = $form.parsley();
	
	                parsley.on('field:validated', function (_ref) {
	                    var $element = _ref.$element;
	
	                    // Make sure errors reported by the server get removed
	                    $element.siblings('.float-label_errors').remove();
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dependency = dependency;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Loads an external Javascript file and executes it.
	 *
	 * @param url - The URL to the Javascript file
	 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
	 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
	 *   this function could check whether the jQuery property exists on the window object.
	 * @return Promise
	 */
	var loadedDependencies = null;
	function dependency(url) {
	    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	        return true;
	    };
	    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	
	    if (!loadedDependencies) {
	        loadedDependencies = {};
	
	        // Add existing Javascript files as dependencies
	        // TODO Handle `defer` and `async`
	        (0, _jquery2.default)('script[src]').each(function () {
	            var src = (0, _jquery2.default)(this).prop('src');
	            loadedDependencies[src] = true;
	        });
	    }
	
	    return new Promise(function (resolve, reject) {
	
	        var startTime = Date.now();
	        function poll() {
	            if (check()) {
	                resolve();
	            } else if (Date.now() - startTime > timeout) {
	                reject();
	            } else {
	                setTimeout(poll, 50);
	            }
	        }
	
	        if (!loadedDependencies[url]) {
	            loadedDependencies[url] = true;
	            _jquery2.default.getScript(url).done(poll).fail(reject);
	        } else {
	            poll();
	        }
	    });
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = lightboxDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(15);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _data = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the PhotoSwipe library.
	 *
	 * @see http://photoswipe.com
	 * @type {string}
	 */
	var photoswipeDir = 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/';
	
	/**
	 * The reusable template for PhotoSwipe.
	 *
	 * @see http://photoswipe.com/documentation/getting-started.html
	 */
	var template = '\n    <div id="lightbox" class="pswp lightbox" tabindex="-1" role="dialog" aria-hidden="true">\n        <div class="pswp__bg"></div>\n        <div class="pswp__scroll-wrap">\n            <div class="pswp__container">\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n            </div>\n            <div class="pswp__ui pswp__ui--hidden">\n                <div class="pswp__top-bar">\n                    <div class="pswp__counter"></div>\n                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                    <button class="pswp__button pswp__button--share" title="Share"></button>\n                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                    <div class="pswp__preloader">\n                        <div class="pswp__preloader__icn">\n                          <div class="pswp__preloader__cut">\n                            <div class="pswp__preloader__donut"></div>\n                          </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                    <div class="pswp__share-tooltip"></div>\n                </div>\n                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n                <div class="pswp__caption">\n                    <div class="pswp__caption__center"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
	
	/**
	 *
	 * @param element
	 * @returns {{}}
	 */
	function getConfigFromElement(element) {
	    // TODO
	    return {};
	}
	
	var initialised = false;
	var pswpElement = null;
	
	/**
	 * Initializes a PhotoSwipe gallery.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function lightboxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $lightboxes = $context.find('[sw-lightbox]');
	
	    if ($lightboxes.length > 0) {
	
	        if (!initialised) {
	            initialised = true;
	
	            (0, _jquery2.default)('head').append('\n                <link rel="stylesheet" href="' + photoswipeDir + 'photoswipe.min.css">\n                <link rel="stylesheet" href="' + photoswipeDir + 'default-skin/default-skin.min.css">\n            ');
	
	            (0, _jquery2.default)('body').append(template);
	
	            pswpElement = (0, _jquery2.default)('#lightbox')[0];
	        }
	
	        (0, _request.dependency)(photoswipeDir + 'photoswipe.min.js');
	        (0, _request.dependency)(photoswipeDir + 'photoswipe-ui-default.min.js', function () {
	            return window.PhotoSwipe && window.PhotoSwipeUI_Default;
	        }).then(function () {
	            var groups = {};
	
	            $lightboxes.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-lightbox');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    group: null,
	                    thumbnailUrl: '',
	                    html: '',
	                    url: '',
	                    width: 1280,
	                    height: 720,
	                    title: null
	                }, 'url');
	
	                settings.group = settings.group || (0, _data.uniqueId)();
	
	                if (!(settings.group in groups)) {
	                    groups[settings.group] = {
	                        elements: [],
	                        items: []
	                    };
	                }
	
	                var group = groups[settings.group];
	                var item = {
	                    msrc: settings.thumbnailUrl,
	                    w: settings.width | 0,
	                    h: settings.height | 0,
	                    title: settings.title
	                };
	
	                if (settings.html) {
	                    item.html = settings.html;
	                } else {
	                    item.src = settings.url;
	                }
	
	                group.elements.push(this);
	                group.items.push(item);
	
	                $element.on('click', function (e) {
	                    e.preventDefault();
	
	                    var options = {
	                        history: false,
	                        index: group.elements.indexOf(this),
	                        getThumbBoundsFn: function getThumbBoundsFn(index) {
	                            var $currentElement = (0, _jquery2.default)(group.elements[index]);
	                            var $thumb = $currentElement.is('[sw-lightbox-thumb]') ? $currentElement : $currentElement.find('[sw-lightbox-thumb]');
	                            var offset = $thumb.offset();
	                            var width = $thumb.width();
	                            var height = $thumb.height();
	
	                            // If the thumbnail has been letterboxed, this will get the correct width
	                            var trueWidth = Math.min(width, height / settings.height * settings.width);
	
	                            return offset ? {
	                                x: offset.left + (width - trueWidth) / 2,
	                                y: offset.top,
	                                w: trueWidth
	                            } : null;
	                        }
	                    };
	
	                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, group.items, options);
	                    gallery.init();
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uniqueId = uniqueId;
	/**
	 * Generates a unique ID.
	 *
	 * @returns String
	 */
	var existingUniqueIds = {};
	function uniqueId() {
	    var range = Math.pow(10, 9);
	    var id = null;
	    while (!id || existingUniqueIds[id]) {
	        id = 'id' + (Math.random() * range | 0).toString(36);
	    }
	    existingUniqueIds[id] = true;
	    return id;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = playOnHoverDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function playOnHoverDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $element = (0, _jquery2.default)(context).find('[sw-play-on-hover]');
	
	    $element.each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var $videos = $this.find('video');
	
	        $this.on('mouseenter', function () {
	            $videos.each(function () {
	                if (!this.ended || this.loop) {
	                    this.play();
	                }
	            });
	        }).on('mouseleave', function () {
	            $videos.each(function () {
	                this.pause();
	            });
	        });
	    });
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = swiperDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(15);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Swiper library.
	 *
	 * @see http://idangero.us/swiper
	 * @type {string}
	 */
	var swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.4.2/';
	
	var addedCss = false;
	
	/**
	 * Initializes a Swiper carousel.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function swiperDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $swipers = $context.find('[sw-swiper]');
	
	    if ($swipers.length > 0) {
	
	        if (!addedCss) {
	            addedCss = true;
	            (0, _jquery2.default)('head').append('<link rel="stylesheet" href="' + swiperDir + 'css/swiper.min.css">');
	        }
	
	        (0, _request.dependency)(swiperDir + 'js/swiper.min.js', function () {
	            return window.Swiper;
	        }).then(function () {
	            $swipers.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-swiper');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    loop: true,
	                    preloadImages: false,
	                    lazyLoading: true,
	                    lazyLoadingInPrevNext: true,
	                    paginationElement: 'button',
	                    paginationClickable: true,
	                    runCallbacksOnInit: true
	                });
	
	                var $slides = $element.find('.swiper-slide');
	                var swiper = $slides.length > 1 ? new Swiper(this, settings) : false;
	
	                (0, _drawing.frame)(function () {
	                    return $element.addClass('swiper-ready');
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = lazyLoadDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _blazy = __webpack_require__(21);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _data = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Lazily loads images, backgrounds, videos and iframes.
	 *
	 * @see http://dinbror.dk/blog/blazy/
	 * @param context
	 */
	function lazyLoadDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var container = 'window';
	
		/*
	  * Problem:
	  *   Blazy library only supports a string selector for the container element.
	  *   This means that the `context` argument above cannot be passed directly as a DOM element to the Blazy
	  *   initialisation function.
	  *
	  * Solution:
	  *   Generate a unique attribute for the element, add it to the element, then use a selector targeting that
	  *   attribute.
	  */
		if (context !== document.body) {
			var uniqueAttr = 'data-' + (0, _data.uniqueId)();
			container = '[' + uniqueAttr + ']';
	
			(0, _jquery2.default)(context).attr(uniqueAttr, true);
		}
	
		new _blazy2.default({
			container: container,
			selector: '[sw-lazy-load]',
			src: 'sw-lazy-load',
			successClass: 'is-ready',
			errorClass: 'is-broken'
		});
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  hey, [be]Lazy.js - v1.8.2 - 2016.10.25
	  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function(root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(this, function() {
	    'use strict';
	
	    //private vars
	    var _source, _viewport, _isRetina, _supportClosest, _attrSrc = 'src', _attrSrcset = 'srcset';
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function(r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
	                    s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.root = scope.options.root || document;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.containerClass = scope.options.container;
	        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false;
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.srcset = scope.options.srcset || 'data-srcset';
	        scope.options.src = _source = scope.options.src || 'data-src';
	        _supportClosest = Element.prototype.closest;
	        _isRetina = window.devicePixelRatio > 1;
	        _viewport = {};
	        _viewport.top = 0 - scope.options.offset;
	        _viewport.left = 0 - scope.options.offset;
	
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function() {
	            initialize(scope);
	        };
	        scope.load = function(elements, force) {
	            var opt = this.options;
	            if (elements && elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function(element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function() {            
	            var util = scope._util;
	            if (scope.options.container) {
	                each(scope.options.container, function(object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function() {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function() {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src (obsolete)
	        each(scope.options.breakpoints, function(object) {
	            if (object.width >= window.screen.width) {
	                _source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        setTimeout(function() {
	            initialize(scope);
	        }); // "dom ready" fix
	
	    };
	
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load.
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele, options) {
	        var rect = ele.getBoundingClientRect();
	
	        if(options.container && _supportClosest){
	            // Is element inside a container?
	            var elementContainer = ele.closest(options.containerClass);
	            if(elementContainer){
	                var containerRect = elementContainer.getBoundingClientRect();
	                // Is container in view?
	                if(inView(containerRect, _viewport)){
	                    var top = containerRect.top - options.offset;
	                    var right = containerRect.right + options.offset;
	                    var bottom = containerRect.bottom + options.offset;
	                    var left = containerRect.left - options.offset;
	                    var containerRectWithOffset = {
	                        top: top > _viewport.top ? top : _viewport.top,
	                        right: right < _viewport.right ? right : _viewport.right,
	                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
	                        left: left > _viewport.left ? left : _viewport.left
	                    };
	                    // Is element in view of container?
	                    return inView(rect, containerRectWithOffset);
	                } else {
	                    return false;
	                }
	            }
	        }      
	        return inView(rect, _viewport);
	    }
	
	    function inView(rect, viewport){
	        // Intersection
	        return rect.right >= viewport.left &&
	               rect.bottom >= viewport.top && 
	               rect.left <= viewport.right && 
	               rect.top <= viewport.bottom;
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || (ele.offsetWidth > 0 && ele.offsetHeight > 0))) {
	            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var srcset = getAttr(ele, options.srcset);
	                var isImage = equal(ele, 'img');
	                var parent = ele.parentNode;
	                var isPicture = parent && equal(parent, 'picture');
	                // Image or background image
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    // using EventListener instead of onerror and onload
	                    // due to bug introduced in chrome v50 
	                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
	                    var onErrorHandler = function() {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                        unbindEvent(img, 'error', onErrorHandler);
	                        unbindEvent(img, 'load', onLoadHandler);
	                    };
	                    var onLoadHandler = function() {
	                        // Is element an image
	                        if (isImage) {
	                            if(!isPicture) {
	                                handleSources(ele, src, srcset);
	                            }
	                        // or background-image
	                        } else {
	                            ele.style.backgroundImage = 'url("' + src + '")';
	                        }
	                        itemLoaded(ele, options);
	                        unbindEvent(img, 'load', onLoadHandler);
	                        unbindEvent(img, 'error', onErrorHandler);
	                    };
	                    
	                    // Picture element
	                    if (isPicture) {
	                        img = ele; // Image tag inside picture element wont get preloaded
	                        each(parent.getElementsByTagName('source'), function(source) {
	                            handleSource(source, _attrSrcset, options.srcset);
	                        });
	                    }
	                    bindEvent(img, 'error', onErrorHandler);
	                    bindEvent(img, 'load', onLoadHandler);
	                    handleSources(img, src, srcset); // Preload
	
	                } else { // An item with src like iframe, unity games, simpel video etc
	                    ele.src = src;
	                    itemLoaded(ele, options);
	                }
	            } else {
	                // video with child source
	                if (equal(ele, 'video')) {
	                    each(ele.getElementsByTagName('source'), function(source) {
	                        handleSource(source, _attrSrc, options.src);
	                    });
	                    ele.load();
	                    itemLoaded(ele, options);
	                } else {
	                    if (options.error) options.error(ele, "missing");
	                    addClass(ele, options.errorClass);
	                }
	            }
	        }
	    }
	
	    function itemLoaded(ele, options) {
	        addClass(ele, options.successClass);
	        if (options.success) options.success(ele);
	        // cleanup markup, remove data source attributes
	        removeAttr(ele, options.src);
	        removeAttr(ele, options.srcset);
	        each(options.breakpoints, function(object) {
	            removeAttr(ele, object.src);
	        });
	    }
	
	    function handleSource(ele, attr, dataAttr) {
	        var dataSrc = getAttr(ele, dataAttr);
	        if (dataSrc) {
	            setAttr(ele, attr, dataSrc);
	            removeAttr(ele, dataAttr);
	        }
	    }
	
	    function handleSources(ele, src, srcset){
	        if(srcset) {
	            setAttr(ele, _attrSrcset, srcset); //srcset
	        }
	        ele.src = src; //src 
	    }
	
	    function setAttr(ele, attr, value){
	        ele.setAttribute(attr, value);
	    }
	
	    function getAttr(ele, attr) {
	        return ele.getAttribute(attr);
	    }
	
	    function removeAttr(ele, attr){
	        ele.removeAttribute(attr); 
	    }
	
	    function equal(ele, str) {
	        return ele.nodeName.toLowerCase() === str;
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        if (!hasClass(ele, className)) {
	            ele.className += ' ' + className;
	        }
	    }
	
	    function toArray(options) {
	        var array = [];
	        var nodelist = (options.root).querySelectorAll(options.selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function() {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = parallaxDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inspection = __webpack_require__(23);
	
	var _drawing = __webpack_require__(10);
	
	var _window = __webpack_require__(24);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds parallax to an element.
	 *
	 * Parallax with 75% speed: <div sw-parallax="0.75"></div>
	 * Parallax for background images: <div sw-parallax='{"scale": true}'></div>
	 *
	 * @param context
	 */
	function parallaxDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		if (!(0, _inspection.isTouch)()) {
			var $context = (0, _jquery2.default)(context);
			var $window = (0, _jquery2.default)(window);
	
			$context.find('[sw-parallax]').each(function () {
				var $element = (0, _jquery2.default)(this);
				var json = $element.attr('sw-parallax');
				var settings = (0, _parse.directiveSettings)(json, {
					speed: 0.5,
					align: 0.5,
					scale: false
				}, 'speed');
	
				var height = void 0;
				var offset = void 0;
				var transform = void 0;
	
				function setup() {
					$element.css('transform', '');
					$element.css('transform-origin', 'top center');
	
					(0, _drawing.redraw)($element);
	
					height = $element.outerHeight();
					offset = $element.offset();
	
					if (settings.scale) {
						var viewHeight = Math.min((0, _window.getHeight)(), offset.top + height);
						var newHeight = Math.max(viewHeight - (viewHeight - height) * settings.speed, height);
						transform = 'scale(' + newHeight / height + ')';
					} else {
						transform = '';
					}
	
					position();
				}
	
				function position() {
					var scaleOffset = settings.scale ? 0 : ((0, _window.getHeight)() - height) * settings.align;
					var translate = ((0, _window.getScrollTop)() - offset.top + scaleOffset) * (settings.speed - 1);
	
					$element.css('transform', 'translate3d(0, ' + -translate + 'px, 0) ' + transform);
				}
	
				setup();
				(0, _jquery2.default)(function () {
					return (0, _drawing.frame)(setup);
				});
				$window.on('load resize', function () {
					return (0, _drawing.frame)(setup);
				});
				$window.on('scroll', function () {
					return (0, _drawing.frame)(position);
				});
			});
		}
	}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isTouch = isTouch;
	exports.isIE = isIE;
	/**
	 * Crude check to see if the device is a touch screen.
	 * @see http://stackoverflow.com/a/4819886/556609
	 *
	 * @returns {boolean}
	 */
	function isTouch() {
	    return 'ontouchstart' in window || !!navigator.maxTouchPoints;
	}
	
	/**
	 * Crude check to see if the browser is IE.
	 *
	 * @param version - Optionally check a specific version (11, 10, or 9)
	 * @returns {boolean}
	 */
	function isIE() {
	    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    var ua = navigator.userAgent;
	    var is11 = /rv:11\.0/i.test(ua);
	    var is10 = /MSIE 10/i.test(ua);
	    var is9 = /MSIE 9/i.test(ua);
	
	    switch (version) {
	        case 11:
	            return is11;
	        case 10:
	            return is10;
	        case 9:
	            return is9;
	    }
	
	    return is11 && is10 && is9;
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getProperties = getProperties;
	exports.getWidth = getWidth;
	exports.getHeight = getHeight;
	exports.getScrollTop = getScrollTop;
	exports.getScrollLeft = getScrollLeft;
	exports.getScrollWidth = getScrollWidth;
	exports.getScrollHeight = getScrollHeight;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	var properties = {};
	
	function updateDimensions() {
	    properties.width = $window.width();
	    properties.height = $window.height();
	}
	
	function updateScroll() {
	    properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	    properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
	    properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
	    properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
	}
	
	updateDimensions();
	updateScroll();
	
	$window.on('resize', function () {
	    updateDimensions();updateScroll();
	});
	$window.on('scroll', function () {
	    updateScroll();
	});
	
	/**
	 * Returns all the above properties of the window object.
	 *
	 * @returns Object
	 */
	function getProperties() {
	    return Object.assign({}, properties);
	}
	
	/**
	 * Returns the width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getWidth() {
	    return properties.width;
	}
	
	/**
	 * Returns the height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getHeight() {
	    return properties.height;
	}
	
	/**
	 * Returns the top scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollTop() {
	    return properties.scrollTop;
	}
	
	/**
	 * Returns the left scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollLeft() {
	    return properties.scrollLeft;
	}
	
	/**
	 * Returns the scrollable width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollWidth() {
	    return properties.scrollWidth;
	}
	
	/**
	 * Returns the scrollable height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollHeight() {
	    return properties.scrollHeight;
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = revealDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inspection = __webpack_require__(23);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	
	function revealDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
		var $reveal = $context.find('[sw-reveal]');
	
		if (!(0, _inspection.isTouch)()) {
			var checkForReveal = function checkForReveal() {
				var $this = (0, _jquery2.default)(this);
				var isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top;
				if (isScrolled && !$this.hasClass('is-revealed')) {
					$this.addClass('is-revealed');
				}
			};
	
			$reveal.css('transition', 'none');
			$reveal.each(checkForReveal);
			(0, _drawing.frame)(function () {
				return $reveal.css('transition', '');
			});
	
			var currentReveal = void 0;
			$window.on('resize scroll', function () {
				(0, _drawing.unframe)(currentReveal);
				currentReveal = (0, _drawing.frame)(function () {
					return $reveal.each(checkForReveal);
				});
			});
		} else {
			$reveal.css('transition', 'none');
			$reveal.addClass('is-revealed');
		}
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stickyDirective;
	
	var _jquery = __webpack_require__(2);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sticks an element top the top of the screen.
	 * TODO Allow for a sticky container to stop elements sticking too far.
	 *
	 * @param context
	 */
	function stickyDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-sticky]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-sticky');
	        var settings = (0, _parse.directiveSettings)(json, {
	            name: '',
	            offset: 0
	        }, 'name');
	
	        var $filler = settings.name ? $context.find('[sw-sticky-filler=\'' + settings.name + '\']') : (0, _jquery2.default)();
	        if ($filler.length === 0) {
	            $filler = (0, _jquery2.default)('<div sw-sticky-filler="' + settings.name + '">');
	            $element.before($filler);
	        }
	
	        var isFixed = false;
	
	        function fillerSize() {
	            $filler.css('height', $element.outerHeight() + 'px');
	        }
	
	        function stickyScroll() {
	            if (isFixed) {
	                var fillerTop = $filler.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() <= fillerTop) {
	                    isFixed = false;
	                    fixSticky(false);
	                }
	            } else {
	                var stickyTop = $element.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() > stickyTop) {
	                    isFixed = true;
	                    fixSticky(true);
	                }
	            }
	        }
	
	        function fixSticky(fix) {
	            if (fix) {
	                $filler.css('display', '');
	                $element.addClass('is-stuck').removeClass('is-unstuck');
	            } else {
	                $filler.css('display', 'none');
	                $element.removeClass('is-stuck').addClass('is-unstuck');
	            }
	        }
	
	        fillerSize();
	        fixSticky(false);
	        stickyScroll();
	
	        $window.on('resize', fillerSize);
	        $window.on('resize scroll', stickyScroll);
	    });
	}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define("Barba", [], factory);
		else if(typeof exports === 'object')
			exports["Barba"] = factory();
		else
			root["Barba"] = factory();
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "http://localhost:8080/dist";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		//Promise polyfill https://github.com/taylorhakes/promise-polyfill
		
		if (typeof Promise !== 'function') {
		 window.Promise = __webpack_require__(1);
		}
		
		var Barba = {
		  version: '1.0.0',
		  BaseTransition: __webpack_require__(4),
		  BaseView: __webpack_require__(6),
		  BaseCache: __webpack_require__(8),
		  Dispatcher: __webpack_require__(7),
		  HistoryManager: __webpack_require__(9),
		  Pjax: __webpack_require__(10),
		  Prefetch: __webpack_require__(13),
		  Utils: __webpack_require__(5)
		};
		
		module.exports = Barba;
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {
		
		  // Store setTimeout reference so promise-polyfill will be unaffected by
		  // other code modifying setTimeout (like sinon.useFakeTimers())
		  var setTimeoutFunc = setTimeout;
		
		  function noop() {
		  }
		
		  // Use polyfill for setImmediate for performance gains
		  var asap = (typeof setImmediate === 'function' && setImmediate) ||
		    function (fn) {
		      setTimeoutFunc(fn, 0);
		    };
		
		  var onUnhandledRejection = function onUnhandledRejection(err) {
		    if (typeof console !== 'undefined' && console) {
		      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
		    }
		  };
		
		  // Polyfill for Function.prototype.bind
		  function bind(fn, thisArg) {
		    return function () {
		      fn.apply(thisArg, arguments);
		    };
		  }
		
		  function Promise(fn) {
		    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
		    if (typeof fn !== 'function') throw new TypeError('not a function');
		    this._state = 0;
		    this._handled = false;
		    this._value = undefined;
		    this._deferreds = [];
		
		    doResolve(fn, this);
		  }
		
		  function handle(self, deferred) {
		    while (self._state === 3) {
		      self = self._value;
		    }
		    if (self._state === 0) {
		      self._deferreds.push(deferred);
		      return;
		    }
		    self._handled = true;
		    asap(function () {
		      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
		      if (cb === null) {
		        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
		        return;
		      }
		      var ret;
		      try {
		        ret = cb(self._value);
		      } catch (e) {
		        reject(deferred.promise, e);
		        return;
		      }
		      resolve(deferred.promise, ret);
		    });
		  }
		
		  function resolve(self, newValue) {
		    try {
		      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
		      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
		      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
		        var then = newValue.then;
		        if (newValue instanceof Promise) {
		          self._state = 3;
		          self._value = newValue;
		          finale(self);
		          return;
		        } else if (typeof then === 'function') {
		          doResolve(bind(then, newValue), self);
		          return;
		        }
		      }
		      self._state = 1;
		      self._value = newValue;
		      finale(self);
		    } catch (e) {
		      reject(self, e);
		    }
		  }
		
		  function reject(self, newValue) {
		    self._state = 2;
		    self._value = newValue;
		    finale(self);
		  }
		
		  function finale(self) {
		    if (self._state === 2 && self._deferreds.length === 0) {
		      asap(function() {
		        if (!self._handled) {
		          onUnhandledRejection(self._value);
		        }
		      });
		    }
		
		    for (var i = 0, len = self._deferreds.length; i < len; i++) {
		      handle(self, self._deferreds[i]);
		    }
		    self._deferreds = null;
		  }
		
		  function Handler(onFulfilled, onRejected, promise) {
		    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
		    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
		    this.promise = promise;
		  }
		
		  /**
		   * Take a potentially misbehaving resolver function and make sure
		   * onFulfilled and onRejected are only called once.
		   *
		   * Makes no guarantees about asynchrony.
		   */
		  function doResolve(fn, self) {
		    var done = false;
		    try {
		      fn(function (value) {
		        if (done) return;
		        done = true;
		        resolve(self, value);
		      }, function (reason) {
		        if (done) return;
		        done = true;
		        reject(self, reason);
		      });
		    } catch (ex) {
		      if (done) return;
		      done = true;
		      reject(self, ex);
		    }
		  }
		
		  Promise.prototype['catch'] = function (onRejected) {
		    return this.then(null, onRejected);
		  };
		
		  Promise.prototype.then = function (onFulfilled, onRejected) {
		    var prom = new (this.constructor)(noop);
		
		    handle(this, new Handler(onFulfilled, onRejected, prom));
		    return prom;
		  };
		
		  Promise.all = function (arr) {
		    var args = Array.prototype.slice.call(arr);
		
		    return new Promise(function (resolve, reject) {
		      if (args.length === 0) return resolve([]);
		      var remaining = args.length;
		
		      function res(i, val) {
		        try {
		          if (val && (typeof val === 'object' || typeof val === 'function')) {
		            var then = val.then;
		            if (typeof then === 'function') {
		              then.call(val, function (val) {
		                res(i, val);
		              }, reject);
		              return;
		            }
		          }
		          args[i] = val;
		          if (--remaining === 0) {
		            resolve(args);
		          }
		        } catch (ex) {
		          reject(ex);
		        }
		      }
		
		      for (var i = 0; i < args.length; i++) {
		        res(i, args[i]);
		      }
		    });
		  };
		
		  Promise.resolve = function (value) {
		    if (value && typeof value === 'object' && value.constructor === Promise) {
		      return value;
		    }
		
		    return new Promise(function (resolve) {
		      resolve(value);
		    });
		  };
		
		  Promise.reject = function (value) {
		    return new Promise(function (resolve, reject) {
		      reject(value);
		    });
		  };
		
		  Promise.race = function (values) {
		    return new Promise(function (resolve, reject) {
		      for (var i = 0, len = values.length; i < len; i++) {
		        values[i].then(resolve, reject);
		      }
		    });
		  };
		
		  /**
		   * Set the immediate function to execute callbacks
		   * @param fn {function} Function to execute
		   * @private
		   */
		  Promise._setImmediateFn = function _setImmediateFn(fn) {
		    asap = fn;
		  };
		
		  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
		    onUnhandledRejection = fn;
		  };
		
		  if (typeof module !== 'undefined' && module.exports) {
		    module.exports = Promise;
		  } else if (!root.Promise) {
		    root.Promise = Promise;
		  }
		
		})(this);
		
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).setImmediate))
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(3).nextTick;
		var apply = Function.prototype.apply;
		var slice = Array.prototype.slice;
		var immediateIds = {};
		var nextImmediateId = 0;
		
		// DOM APIs, for completeness
		
		exports.setTimeout = function() {
		  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
		};
		exports.setInterval = function() {
		  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
		};
		exports.clearTimeout =
		exports.clearInterval = function(timeout) { timeout.close(); };
		
		function Timeout(id, clearFn) {
		  this._id = id;
		  this._clearFn = clearFn;
		}
		Timeout.prototype.unref = Timeout.prototype.ref = function() {};
		Timeout.prototype.close = function() {
		  this._clearFn.call(window, this._id);
		};
		
		// Does not start the time, just sets up the members needed.
		exports.enroll = function(item, msecs) {
		  clearTimeout(item._idleTimeoutId);
		  item._idleTimeout = msecs;
		};
		
		exports.unenroll = function(item) {
		  clearTimeout(item._idleTimeoutId);
		  item._idleTimeout = -1;
		};
		
		exports._unrefActive = exports.active = function(item) {
		  clearTimeout(item._idleTimeoutId);
		
		  var msecs = item._idleTimeout;
		  if (msecs >= 0) {
		    item._idleTimeoutId = setTimeout(function onTimeout() {
		      if (item._onTimeout)
		        item._onTimeout();
		    }, msecs);
		  }
		};
		
		// That's not how node.js implements it but the exposed api is the same.
		exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
		  var id = nextImmediateId++;
		  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
		
		  immediateIds[id] = true;
		
		  nextTick(function onNextTick() {
		    if (immediateIds[id]) {
		      // fn.call() is faster so we optimize for the common use-case
		      // @see http://jsperf.com/call-apply-segu
		      if (args) {
		        fn.apply(null, args);
		      } else {
		        fn.call(null);
		      }
		      // Prevent ids from leaking
		      exports.clearImmediate(id);
		    }
		  });
		
		  return id;
		};
		
		exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
		  delete immediateIds[id];
		};
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).setImmediate, __webpack_require__(2).clearImmediate))
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		// shim for using process in browser
		
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		(function () {
		  try {
		    cachedSetTimeout = setTimeout;
		  } catch (e) {
		    cachedSetTimeout = function () {
		      throw new Error('setTimeout is not defined');
		    }
		  }
		  try {
		    cachedClearTimeout = clearTimeout;
		  } catch (e) {
		    cachedClearTimeout = function () {
		      throw new Error('clearTimeout is not defined');
		    }
		  }
		} ())
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = cachedSetTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    cachedClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        cachedSetTimeout(drainQueue, 0);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Utils = __webpack_require__(5);
		
		/**
		 * BaseTransition to extend
		 *
		 * @namespace Barba.BaseTransition
		 * @type {Object}
		 */
		var BaseTransition = {
		  /**
		   * @memberOf Barba.BaseTransition
		   * @type {HTMLElement}
		   */
		  oldContainer: undefined,
		
		  /**
		   * @memberOf Barba.BaseTransition
		   * @type {HTMLElement}
		   */
		  newContainer: undefined,
		
		  /**
		   * @memberOf Barba.BaseTransition
		   * @type {Promise}
		   */
		  newContainerLoading: undefined,
		
		  /**
		   * Helper to extend the object
		   *
		   * @memberOf Barba.BaseTransition
		   * @param  {Object} newObject
		   * @return {Object} newInheritObject
		   */
		  extend: function(obj){
		    return Utils.extend(this, obj);
		  },
		
		  /**
		   * This function is called from Pjax module to initialize
		   * the transition.
		   *
		   * @memberOf Barba.BaseTransition
		   * @private
		   * @param  {HTMLElement} oldContainer
		   * @param  {Promise} newContainer
		   * @return {Promise}
		   */
		  init: function(oldContainer, newContainer) {
		    var _this = this;
		
		    this.oldContainer = oldContainer;
		    this._newContainerPromise = newContainer;
		
		    this.deferred = Utils.deferred();
		    this.newContainerReady = Utils.deferred();
		    this.newContainerLoading = this.newContainerReady.promise;
		
		    this.start();
		
		    this._newContainerPromise.then(function(newContainer) {
		      _this.newContainer = newContainer;
		      _this.newContainerReady.resolve();
		    });
		
		    return this.deferred.promise;
		  },
		
		  /**
		   * This function needs to be called as soon the Transition is finished
		   *
		   * @memberOf Barba.BaseTransition
		   */
		  done: function() {
		    this.oldContainer.parentNode.removeChild(this.oldContainer);
		    this.newContainer.style.visibility = 'visible';
		    this.deferred.resolve();
		  },
		
		  /**
		   * Constructor for your Transition
		   *
		   * @memberOf Barba.BaseTransition
		   * @abstract
		   */
		  start: function() {},
		};
		
		module.exports = BaseTransition;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports) {
	
		/**
		 * Just an object with some helpful functions
		 *
		 * @type {Object}
		 * @namespace Barba.Utils
		 */
		var Utils = {
		  /**
		   * Return the current url
		   *
		   * @memberOf Barba.Utils
		   * @return {String} currentUrl
		   */
		  getCurrentUrl: function() {
		    return window.location.protocol + '//' +
		           window.location.host +
		           window.location.pathname +
		           window.location.search;
		  },
		
		  /**
		   * Given an url, return it without the hash
		   *
		   * @memberOf Barba.Utils
		   * @private
		   * @param  {String} url
		   * @return {String} newCleanUrl
		   */
		  cleanLink: function(url) {
		    return url.replace(/#.*/, '');
		  },
		
		  /**
		   * Time in millisecond after the xhr request goes in timeout
		   *
		   * @memberOf Barba.Utils
		   * @type {Number}
		   * @default
		   */
		  xhrTimeout: 5000,
		
		  /**
		   * Start an XMLHttpRequest() and return a Promise
		   *
		   * @memberOf Barba.Utils
		   * @param  {String} url
		   * @return {Promise}
		   */
		  xhr: function(url) {
		    var deferred = this.deferred();
		    var req = new XMLHttpRequest();
		
		    req.onreadystatechange = function() {
		      if (req.readyState === 4) {
		        if (req.status === 200) {
		          return deferred.resolve(req.responseText);
		        } else {
		          return deferred.reject(new Error('xhr: HTTP code is not 200'));
		        }
		      }
		    };
		
		    req.ontimeout = function() {
		      return deferred.reject(new Error('xhr: Timeout exceeded'));
		    };
		
		    req.open('GET', url);
		    req.timeout = this.xhrTimeout;
		    req.setRequestHeader('x-barba', 'yes');
		    req.send();
		
		    return deferred.promise;
		  },
		
		  /**
		   * Get obj and props and return a new object with the property merged
		   *
		   * @memberOf Barba.Utils
		   * @param  {object} obj
		   * @param  {object} props
		   * @return {object}
		   */
		  extend: function(obj, props) {
		    var newObj = Object.create(obj);
		
		    for(var prop in props) {
		      if(props.hasOwnProperty(prop)) {
		        newObj[prop] = props[prop];
		      }
		    }
		
		    return newObj;
		  },
		
		  /**
		   * Return a new "Deferred" object
		   * https://developer.mozilla.org/en-US/docs/Mozilla/JavaScript_code_modules/Promise.jsm/Deferred
		   *
		   * @memberOf Barba.Utils
		   * @return {Deferred}
		   */
		  deferred: function() {
		    return new function() {
		      this.resolve = null;
		      this.reject = null;
		
		      this.promise = new Promise(function(resolve, reject) {
		        this.resolve = resolve;
		        this.reject = reject;
		      }.bind(this));
		    };
		  },
		
		  /**
		   * Return the port number normalized, eventually you can pass a string to be normalized.
		   *
		   * @memberOf Barba.Utils
		   * @private
		   * @param  {String} p
		   * @return {Int} port
		   */
		  getPort: function(p) {
		    var port = typeof p !== 'undefined' ? p : window.location.port;
		    var protocol = window.location.protocol;
		
		    if (port != '')
		      return parseInt(port);
		
		    if (protocol === 'http:')
		      return 80;
		
		    if (protocol === 'https:')
		      return 443;
		  }
		};
		
		module.exports = Utils;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Dispatcher = __webpack_require__(7);
		var Utils = __webpack_require__(5);
		
		/**
		 * BaseView to be extended
		 *
		 * @namespace Barba.BaseView
		 * @type {Object}
		 */
		var BaseView  = {
		  /**
		   * Namespace of the view.
		   * (need to be associated with the data-namespace of the container)
		   *
		   * @memberOf Barba.BaseView
		   * @type {String}
		   */
		  namespace: null,
		
		  /**
		   * Helper to extend the object
		   *
		   * @memberOf Barba.BaseView
		   * @param  {Object} newObject
		   * @return {Object} newInheritObject
		   */
		  extend: function(obj){
		    return Utils.extend(this, obj);
		  },
		
		  /**
		   * Init the view.
		   * P.S. Is suggested to init the view before starting Barba.Pjax.start(),
		   * in this way .onEnter() and .onEnterCompleted() will be fired for the current
		   * container when the page is loaded.
		   *
		   * @memberOf Barba.BaseView
		   */
		  init: function() {
		    var _this = this;
		
		    Dispatcher.on('initStateChange',
		      function(newStatus, oldStatus) {
		        if (oldStatus && oldStatus.namespace === _this.namespace)
		          _this.onLeave();
		      }
		    );
		
		    Dispatcher.on('newPageReady',
		      function(newStatus, oldStatus, container) {
		        _this.container = container;
		
		        if (newStatus.namespace === _this.namespace)
		          _this.onEnter();
		      }
		    );
		
		    Dispatcher.on('transitionCompleted',
		      function(newStatus, oldStatus) {
		        if (newStatus.namespace === _this.namespace)
		          _this.onEnterCompleted();
		
		        if (oldStatus && oldStatus.namespace === _this.namespace)
		          _this.onLeaveCompleted();
		      }
		    );
		  },
		
		 /**
		  * This function will be fired when the container
		  * is ready and attached to the DOM.
		  *
		  * @memberOf Barba.BaseView
		  * @abstract
		  */
		  onEnter: function() {},
		
		  /**
		   * This function will be fired when the transition
		   * to this container has just finished.
		   *
		   * @memberOf Barba.BaseView
		   * @abstract
		   */
		  onEnterCompleted: function() {},
		
		  /**
		   * This function will be fired when the transition
		   * to a new container has just started.
		   *
		   * @memberOf Barba.BaseView
		   * @abstract
		   */
		  onLeave: function() {},
		
		  /**
		   * This function will be fired when the container
		   * has just been removed from the DOM.
		   *
		   * @memberOf Barba.BaseView
		   * @abstract
		   */
		  onLeaveCompleted: function() {}
		}
		
		module.exports = BaseView;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		/**
		 * Little Dispatcher inspired by MicroEvent.js
		 *
		 * @namespace Barba.Dispatcher
		 * @type {Object}
		 */
		var Dispatcher = {
		  /**
		   * Object that keeps all the events
		   *
		   * @memberOf Barba.Dispatcher
		   * @readOnly
		   * @type {Object}
		   */
		  events: {},
		
		  /**
		   * Bind a callback to an event
		   *
		   * @memberOf Barba.Dispatcher
		   * @param  {String} eventName
		   * @param  {Function} function
		   */
		  on: function(e, f) {
		    this.events[e] = this.events[e] || [];
		    this.events[e].push(f);
		  },
		
		  /**
		   * Unbind event
		   *
		   * @memberOf Barba.Dispatcher
		   * @param  {String} eventName
		   * @param  {Function} function
		   */
		  off: function(e, f) {
		    if(e in this.events === false)
		      return;
		
		    this.events[e].splice(this.events[e].indexOf(f), 1);
		  },
		
		  /**
		   * Fire the event running all the event associated to it
		   *
		   * @memberOf Barba.Dispatcher
		   * @param  {String} eventName
		   * @param  {...*} args
		   */
		  trigger: function(e) {//e, ...args
		    if (e in this.events === false)
		      return;
		
		    for(var i = 0; i < this.events[e].length; i++){
		      this.events[e][i].apply(this, Array.prototype.slice.call(arguments, 1));
		    }
		  }
		};
		
		module.exports = Dispatcher;
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Utils = __webpack_require__(5);
		
		/**
		 * BaseCache it's a simple static cache
		 *
		 * @namespace Barba.BaseCache
		 * @type {Object}
		 */
		var BaseCache = {
		  /**
		   * The Object that keeps all the key value information
		   *
		   * @memberOf Barba.BaseCache
		   * @type {Object}
		   */
		  data: {},
		
		  /**
		   * Helper to extend this object
		   *
		   * @memberOf Barba.BaseCache
		   * @private
		   * @param  {Object} newObject
		   * @return {Object} newInheritObject
		   */
		  extend: function(obj) {
		    return Utils.extend(this, obj);
		  },
		
		  /**
		   * Set a key and value data, mainly Barba is going to save promises
		   *
		   * @memberOf Barba.BaseCache
		   * @param {String} key
		   * @param {*} value
		   */
		  set: function(key, val) {
		    this.data[key] = val;
		  },
		
		  /**
		   * Retrieve the data using the key
		   *
		   * @memberOf Barba.BaseCache
		   * @param  {String} key
		   * @return {*}
		   */
		  get: function(key) {
		    return this.data[key];
		  },
		
		  /**
		   * Flush the cache
		   *
		   * @memberOf Barba.BaseCache
		   */
		  reset: function() {
		    this.data = {};
		  }
		};
		
		module.exports = BaseCache;
	
	
	/***/ },
	/* 9 */
	/***/ function(module, exports) {
	
		/**
		 * HistoryManager helps to keep track of the navigation
		 *
		 * @namespace Barba.HistoryManager
		 * @type {Object}
		 */
		var HistoryManager = {
		  /**
		   * Keep track of the status in historic order
		   *
		   * @memberOf Barba.HistoryManager
		   * @readOnly
		   * @type {Array}
		   */
		  history: [],
		
		  /**
		   * Add a new set of url and namespace
		   *
		   * @memberOf Barba.HistoryManager
		   * @param {String} url
		   * @param {String} namespace
		   * @private
		   */
		  add: function(url, namespace) {
		    if (!namespace)
		      namespace = undefined;
		
		    this.history.push({
		      url: url,
		      namespace: namespace
		    });
		  },
		
		  /**
		   * Return information about the current status
		   *
		   * @memberOf Barba.HistoryManager
		   * @return {Object}
		   */
		  currentStatus: function() {
		    return this.history[this.history.length - 1];
		  },
		
		  /**
		   * Return information about the previous status
		   *
		   * @memberOf Barba.HistoryManager
		   * @return {Object}
		   */
		  prevStatus: function() {
		    var history = this.history;
		
		    if (history.length < 2)
		      return null;
		
		    return history[history.length - 2];
		  }
		};
		
		module.exports = HistoryManager;
	
	
	/***/ },
	/* 10 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Utils = __webpack_require__(5);
		var Dispatcher = __webpack_require__(7);
		var HideShowTransition = __webpack_require__(11);
		var BaseCache = __webpack_require__(8);
		
		var HistoryManager = __webpack_require__(9);
		var Dom = __webpack_require__(12);
		
		/**
		 * Pjax is a static object with main function
		 *
		 * @namespace Barba.Pjax
		 * @borrows Dom as Dom
		 * @type {Object}
		 */
		var Pjax = {
		  Dom: Dom,
		  History: HistoryManager,
		  Cache: BaseCache,
		
		  /**
		   * Indicate wether or not use the cache
		   *
		   * @memberOf Barba.Pjax
		   * @type {Boolean}
		   * @default
		   */
		  cacheEnabled: true,
		
		  /**
		   * Indicate if there is an animation in progress
		   *
		   * @memberOf Barba.Pjax
		   * @readOnly
		   * @type {Boolean}
		   */
		  transitionProgress: false,
		
		  /**
		   * Class name used to ignore links
		   *
		   * @memberOf Barba.Pjax
		   * @type {String}
		   * @default
		   */
		  ignoreClassLink: 'no-barba',
		
		  /**
		   * Function to be called to start Pjax
		   *
		   * @memberOf Barba.Pjax
		   */
		  start: function() {
		    this.init();
		  },
		
		  /**
		   * Init the events
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   */
		  init: function() {
		    var container = this.Dom.getContainer();
		    var wrapper = this.Dom.getWrapper();
		
		    wrapper.setAttribute('aria-live', 'polite');
		
		    this.History.add(
		      this.getCurrentUrl(),
		      this.Dom.getNamespace(container)
		    );
		
		    //Fire for the current view.
		    Dispatcher.trigger('initStateChange', this.History.currentStatus());
		    Dispatcher.trigger('newPageReady',
		      this.History.currentStatus(),
		      {},
		      container,
		      this.Dom.currentHTML
		    );
		    Dispatcher.trigger('transitionCompleted', this.History.currentStatus());
		
		    this.bindEvents();
		  },
		
		  /**
		   * Attach the eventlisteners
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   */
		  bindEvents: function() {
		    document.addEventListener('click',
		      this.onLinkClick.bind(this)
		    );
		
		    window.addEventListener('popstate',
		      this.onStateChange.bind(this)
		    );
		  },
		
		  /**
		   * Return the currentURL cleaned
		   *
		   * @memberOf Barba.Pjax
		   * @return {String} currentUrl
		   */
		  getCurrentUrl: function() {
		    return Utils.cleanLink(
		      Utils.getCurrentUrl()
		    );
		  },
		
		  /**
		   * Change the URL with pushstate and trigger the state change
		   *
		   * @memberOf Barba.Pjax
		   * @param {String} newUrl
		   */
		  goTo: function(url) {
		    window.history.pushState(null, null, url);
		    this.onStateChange();
		  },
		
		  /**
		   * Force the browser to go to a certain url
		   *
		   * @memberOf Barba.Pjax
		   * @param {String} url
		   * @private
		   */
		  forceGoTo: function(url) {
		    window.location = url;
		  },
		
		  /**
		   * Load an url, will start an xhr request or load from the cache
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   * @param  {String} url
		   * @return {Promise}
		   */
		  load: function(url) {
		    var deferred = Utils.deferred();
		    var _this = this;
		    var xhr;
		
		    xhr = this.Cache.get(url);
		
		    if (!xhr) {
		      xhr = Utils.xhr(url);
		      this.Cache.set(url, xhr);
		    }
		
		    xhr.then(
		      function(data) {
		        var container = _this.Dom.parseResponse(data);
		
		        _this.Dom.putContainer(container);
		
		        if (!_this.cacheEnabled)
		          _this.Cache.reset();
		
		        deferred.resolve(container);
		      },
		      function() {
		        //Something went wrong (timeout, 404, 505...)
		        _this.forceGoTo(url);
		
		        deferred.reject();
		      }
		    );
		
		    return deferred.promise;
		  },
		
		  /**
		   * Get the .href parameter out of an element
		   * and handle special cases (like xlink:href)
		   *
		   * @private
		   * @memberOf Barba.Pjax
		   * @param  {HTMLElement} el
		   * @return {String} href
		   */
		  getHref: function(el) {
		    if (!el) {
		      return undefined;
		    }
		
		    if (el.getAttribute && typeof el.getAttribute('xlink:href') === 'string') {
		      return el.getAttribute('xlink:href');
		    }
		
		    if (typeof el.href === 'string') {
		      return el.href;
		    }
		
		    return undefined;
		  },
		
		  /**
		   * Callback called from click event
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   * @param {MouseEvent} evt
		   */
		  onLinkClick: function(evt) {
		    var el = evt.target;
		
		    //Go up in the nodelist until we
		    //find something with an href
		    while (el && !this.getHref(el)) {
		      el = el.parentNode;
		    }
		
		    if (this.preventCheck(evt, el)) {
		      evt.stopPropagation();
		      evt.preventDefault();
		
		      Dispatcher.trigger('linkClicked', el, evt);
		
		      var href = this.getHref(el);
		      this.goTo(href);
		    }
		  },
		
		  /**
		   * Determine if the link should be followed
		   *
		   * @memberOf Barba.Pjax
		   * @param  {MouseEvent} evt
		   * @param  {HTMLElement} element
		   * @return {Boolean}
		   */
		  preventCheck: function(evt, element) {
		    if (!window.history.pushState)
		      return false;
		
		    var href = this.getHref(element);
		
		    //User
		    if (!element || !href)
		      return false;
		
		    //Middle click, cmd click, and ctrl click
		    if (evt.which > 1 || evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey)
		      return false;
		
		    //Ignore target with _blank target
		    if (element.target && element.target === '_blank')
		      return false;
		
		    //Check if it's the same domain
		    if (window.location.protocol !== element.protocol || window.location.hostname !== element.hostname)
		      return false;
		
		    //Check if the port is the same
		    if (Utils.getPort() !== Utils.getPort(element.port))
		      return false;
		
		    //Ignore case when a hash is being tacked on the current URL
		    if (href.indexOf('#') > -1)
		      return false;
		
		    //Ignore case where there is download attribute
		    if (element.getAttribute && typeof element.getAttribute('download') === 'string')
		      return false;
		
		    //In case you're trying to load the same page
		    if (Utils.cleanLink(href) == Utils.cleanLink(location.href))
		      return false;
		
		    if (element.classList.contains(this.ignoreClassLink))
		      return false;
		
		    return true;
		  },
		
		  /**
		   * Return a transition object
		   *
		   * @memberOf Barba.Pjax
		   * @return {Barba.Transition} Transition object
		   */
		  getTransition: function() {
		    //User customizable
		    return HideShowTransition;
		  },
		
		  /**
		   * Method called after a 'popstate' or from .goTo()
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   */
		  onStateChange: function() {
		    var newUrl = this.getCurrentUrl();
		
		    if (this.transitionProgress)
		      this.forceGoTo(newUrl);
		
		    if (this.History.currentStatus().url === newUrl)
		      return false;
		
		    this.History.add(newUrl);
		
		    var newContainer = this.load(newUrl);
		    var transition = Object.create(this.getTransition());
		
		    this.transitionProgress = true;
		
		    Dispatcher.trigger('initStateChange',
		      this.History.currentStatus(),
		      this.History.prevStatus()
		    );
		
		    var transitionInstance = transition.init(
		      this.Dom.getContainer(),
		      newContainer
		    );
		
		    newContainer.then(
		      this.onNewContainerLoaded.bind(this)
		    );
		
		    transitionInstance.then(
		      this.onTransitionEnd.bind(this)
		    );
		  },
		
		  /**
		   * Function called as soon the new container is ready
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   * @param {HTMLElement} container
		   */
		  onNewContainerLoaded: function(container) {
		    var currentStatus = this.History.currentStatus();
		    currentStatus.namespace = this.Dom.getNamespace(container);
		
		    Dispatcher.trigger('newPageReady',
		      this.History.currentStatus(),
		      this.History.prevStatus(),
		      container,
		      this.Dom.currentHTML
		    );
		  },
		
		  /**
		   * Function called as soon the transition is finished
		   *
		   * @memberOf Barba.Pjax
		   * @private
		   */
		  onTransitionEnd: function() {
		    this.transitionProgress = false;
		
		    Dispatcher.trigger('transitionCompleted',
		      this.History.currentStatus(),
		      this.History.prevStatus()
		    );
		  }
		};
		
		module.exports = Pjax;
	
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		var BaseTransition = __webpack_require__(4);
		
		/**
		 * Basic Transition object, wait for the new Container to be ready,
		 * scroll top, and finish the transition (removing the old container and displaying the new one)
		 *
		 * @private
		 * @namespace Barba.HideShowTransition
		 * @augments Barba.BaseTransition
		 */
		var HideShowTransition = BaseTransition.extend({
		  start: function() {
		    this.newContainerLoading.then(this.finish.bind(this));
		  },
		
		  finish: function() {
		    document.body.scrollTop = 0;
		    this.done();
		  }
		});
		
		module.exports = HideShowTransition;
	
	
	/***/ },
	/* 12 */
	/***/ function(module, exports) {
	
		/**
		 * Object that is going to deal with DOM parsing/manipulation
		 *
		 * @namespace Barba.Pjax.Dom
		 * @type {Object}
		 */
		var Dom = {
		  /**
		   * The name of the data attribute on the container
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @type {String}
		   * @default
		   */
		  dataNamespace: 'namespace',
		
		  /**
		   * Id of the main wrapper
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @type {String}
		   * @default
		   */
		  wrapperId: 'barba-wrapper',
		
		  /**
		   * Class name used to identify the containers
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @type {String}
		   * @default
		   */
		  containerClass: 'barba-container',
		
		  /**
		   * Full HTML String of the current page.
		   * By default is the innerHTML of the initial loaded page.
		   *
		   * Each time a new page is loaded, the value is the response of the xhr call.
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @type {String}
		   */
		  currentHTML: document.documentElement.innerHTML,
		
		  /**
		   * Parse the responseText obtained from the xhr call
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @private
		   * @param  {String} responseText
		   * @return {HTMLElement}
		   */
		  parseResponse: function(responseText) {
		    this.currentHTML = responseText;
		
		    var wrapper = document.createElement('div');
		    wrapper.innerHTML = responseText;
		
		    var titleEl = wrapper.querySelector('title');
		
		    if (titleEl)
		      document.title = titleEl.textContent;
		
		    return this.getContainer(wrapper);
		  },
		
		  /**
		   * Get the main barba wrapper by the ID `wrapperId`
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @return {HTMLElement} element
		   */
		  getWrapper: function() {
		    var wrapper = document.getElementById(this.wrapperId);
		
		    if (!wrapper)
		      throw new Error('Barba.js: wrapper not found!');
		
		    return wrapper;
		  },
		
		  /**
		   * Get the container on the current DOM,
		   * or from an HTMLElement passed via argument
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @private
		   * @param  {HTMLElement} element
		   * @return {HTMLElement}
		   */
		  getContainer: function(element) {
		    if (!element)
		      element = document.body;
		
		    if (!element)
		      throw new Error('Barba.js: DOM not ready!');
		
		    var container = this.parseContainer(element);
		
		    if (container && container.jquery)
		      container = container[0];
		
		    if (!container)
		      throw new Error('Barba.js: no container found');
		
		    return container;
		  },
		
		  /**
		   * Get the namespace of the container
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @private
		   * @param  {HTMLElement} element
		   * @return {String}
		   */
		  getNamespace: function(element) {
		    if (element && element.dataset) {
		      return element.dataset[this.dataNamespace];
		    } else if (element) {
		      return element.getAttribute('data-' + this.dataNamespace);
		    }
		
		    return null;
		  },
		
		  /**
		   * Put the container on the page
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @private
		   * @param  {HTMLElement} element
		   */
		  putContainer: function(element) {
		    element.style.visibility = 'hidden';
		
		    var wrapper = this.getWrapper();
		    wrapper.appendChild(element);
		  },
		
		  /**
		   * Get container selector
		   *
		   * @memberOf Barba.Pjax.Dom
		   * @private
		   * @param  {HTMLElement} element
		   * @return {HTMLElement} element
		   */
		  parseContainer: function(element) {
		    return element.querySelector('.' + this.containerClass);
		  }
		};
		
		module.exports = Dom;
	
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		var Utils = __webpack_require__(5);
		var Pjax = __webpack_require__(10);
		
		/**
		 * Prefetch
		 *
		 * @namespace Barba.Prefetch
		 * @type {Object}
		 */
		var Prefetch = {
		  /**
		   * Class name used to ignore prefetch on links
		   *
		   * @memberOf Barba.Prefetch
		   * @type {String}
		   * @default
		   */
		  ignoreClassLink: 'no-barba-prefetch',
		
		  /**
		   * Init the event listener on mouseover and touchstart
		   * for the prefetch
		   *
		   * @memberOf Barba.Prefetch
		   */
		  init: function() {
		    if (!window.history.pushState) {
		      return false;
		    }
		
		    document.body.addEventListener('mouseover', this.onLinkEnter.bind(this));
		    document.body.addEventListener('touchstart', this.onLinkEnter.bind(this));
		  },
		
		  /**
		   * Callback for the mousehover/touchstart
		   *
		   * @memberOf Barba.Prefetch
		   * @private
		   * @param  {Object} evt
		   */
		  onLinkEnter: function(evt) {
		    var el = evt.target;
		
		    while (el && !Pjax.getHref(el)) {
		      el = el.parentNode;
		    }
		
		    if (!el || el.classList.contains(this.ignoreClassLink)) {
		      return;
		    }
		
		    var url = Pjax.getHref(el);
		
		    //Check if the link is elegible for Pjax
		    if (Pjax.preventCheck(evt, el) && !Pjax.Cache.get(url)) {
		      var xhr = Utils.xhr(url);
		      Pjax.Cache.set(url, xhr);
		    }
		  }
		};
		
		module.exports = Prefetch;
	
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=barba.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _barba = __webpack_require__(27);
	
	_barba.Dispatcher.on('initStateChange', function (_ref) {
		var url = _ref.url;
	
	
		var $headerNav = $('#header-nav');
		var $navLinks = $headerNav.find('a');
		var toggler = $headerNav.data('toggler');
	
		// Give it some time before closing to improve UX
		setTimeout(function () {
			return toggler.close();
		}, 400);
	
		$navLinks.removeClass('is-uri is-descendant-uri');
		$navLinks.filter('[href="' + url + '"]').addClass('is-uri');
		// TODO Descendant URI classes should be added... but it's a lot of work for something that would go unnoticed.
	});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js